import axios from 'axios';

import config from './config';

// Separate from Journal's authenticated client: never send Journal/view-as tokens
// to the public tt-core market-data API.
const marketData = axios.create({
    baseURL: config.get('TT_CORE_API_URL'),
    timeout: 30000
});

const getAggregateData = async ({ ticker, multiplier, timespan, fromDate, toDate }) => {
    if (!config.get('TT_CORE_API_URL')) {
        throw new Error('REACT_APP_TT_CORE_API_URL is required for Journal charts');
    }
    const { data } = await marketData.get('/pg/aggregate', {
        params: {
            ticker,
            multiplier,
            timespan,
            // TradingView supplies seconds; both core providers accept Unix milliseconds.
            // Preserve the intraday bounds instead of truncating the final session.
            fromDate: fromDate * 1000,
            toDate: toDate * 1000,
            sortOrder: 'asc',
            limit: 5000
        }
    });
    if (!Array.isArray(data.results)) throw new Error('Invalid chart aggregate response');
    return data.results;
};

export default getAggregateData;
